<div class="container">
  <!-- 未登录 -->
  <ng-container *ngIf="!logined">
    <customize-button
      type="primary-linear"
      class="onact96 btn-login"
      [minWidth]="isH5 ? '8rem' : '10rem'"
      (click)="openLoginDialog()"
    >
      <span class="text-color">{{ 'login_button' | translate }}</span>
    </customize-button>
    <customize-button
      type="secondary-linear"
      class="register-btn onact96"
      [minWidth]="isH5 ? '8rem' : '10rem'"
      (click)="openRegisterDialog()"
    >
      {{ 'register_button' | translate }}
    </customize-button>
  </ng-container>
  <!-- 已登录 -->
  <div class="after-login" *ngIf="logined">
    <div
      class="user-info-wrap"
      (mouseenter)="!isH5 && handleOpen()"
      (click)="isH5 && handleOpen()"
      (mouseleave)="!isH5 && handleClose()"
      cdkOverlayOrigin
      #personalOrigin="cdkOverlayOrigin"
    >
      <div class="user-avatar mutual-opacity">
        <!-- <span *ngIf="bounsCount > 0" class="badge">{{ bounsCount > 99 ? '99+' : bounsCount }}</span> -->
        <img class="avatar" [src]="userInfo?.avater" alt="" lazy="loading" />
      </div>
      <div class="user-vip-info mutual-opacity" *ngIf="!isH5">
        <div class="user-name">{{ userInfo?.userName || userInfo?.uid || '' }}</div>
        <div class="user-vip">
          {{ userDetail?.vipLevelGroupInfo?.vipGroupName }}
        </div>
      </div>
      <ng-template
        cdkConnectedOverlay
        [cdkConnectedOverlayOpen]="expanded || false"
        [cdkConnectedOverlayOrigin]="personalOrigin"
        [cdkConnectedOverlayPositions]="position"
        [cdkConnectedOverlayFlexibleDimensions]="true"
        #personnalDetails
      >
        <div
          class="personal-details"
          @expansion
          (mouseenter)="!isH5 && handleOpen()"
          (mouseleave)="!isH5 && handleClose()"
        >
          <div class="user">
            <i class="icon-error close-anim" *ngIf="isH5" (click)="handleClose()"></i>
            <div class="avatar">
              <img *ngIf="userInfo?.avater" [src]="userInfo?.avater" />
              <div class="level" *ngIf="!userDetail?.isSvip">V{{ userDetail?.currentVipLevel || 0 }}</div>
              <div class="level" *ngIf="userDetail?.isSvip">SVIP</div>
            </div>
            <div class="account">{{ userInfo?.userName }}</div>
          </div>
          <app-scrollbar>
            <div class="vip" *ngIf="userDetail?.isSvip == 0; else svipInfo">
              <div class="process-txt">
                <div>VIP {{ userDetail?.currentVipLevel }}</div>
                <div>
                  <span>{{ diffPoints }} {{ 'xp' | translate }} {{ 'to' | translate }}</span>
                  @if ((userDetail?.currentVipLevel || 0) < 9) {
                    VIP {{ (userDetail?.currentVipLevel || 0) + 1 }}
                  } @else {
                    SVIP
                  }
                </div>
              </div>
              <div class="wrap">
                <div class="process-bar">
                  <div class="bar-fill" [style.width]="percentage"></div>
                </div>
                <div class="percent">{{ percentage }}</div>
              </div>
            </div>
            <ng-template #svipInfo>
              <div class="process-txt">
                <div>SVIP</div>
              </div>
            </ng-template>
            <div class="menu-wrap">
              <div class="menu" *ngFor="let option of topMenu">
                <ng-container *ngFor="let item of option; let index = index">
                  <div
                    class="item"
                    *ngIf="!item.showOnlyCountry"
                    (click)="toMenu(item)"
                    [routerLink]="item?.routerLink"
                    routerLinkActive="active"
                  >
                    <div class="icon">
                      <i class="icon-{{ item.icon }}"></i>
                    </div>
                    <div class="text">{{ item.title | translate }}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </app-scrollbar>
        </div>
      </ng-template>
    </div>
    <!-- im聊天 -->
    <ng-container *ngIf="!isH5 && chatService.chatEnabled">
      <div class="chat-btn" cdkOverlayOrigin #chatOrigin="cdkOverlayOrigin">
        <div class="notice-btn mutual-opacity chat-btn" (click)="chatService.toggleChat(isH5)">
          <i class="icon-chat-vip"></i>
          <p class="notice-number" *ngIf="chatService.unreadCount > 0">
            {{ chatService.unreadCount > 99 ? '99+' : chatService.unreadCount }}
          </p>
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayPanelClass]="'chat-pop-panel'"
            [cdkConnectedOverlayOrigin]="chatOrigin"
            [cdkConnectedOverlayOpen]="chatService.chatPop"
            [cdkConnectedOverlayPositions]="position"
            [cdkConnectedOverlayFlexibleDimensions]="true"
          >
            <!-- (overlayOutsideClick)="" -->
            <app-chat @expansion></app-chat>
          </ng-template>
        </div>
      </div>
    </ng-container>
    <!-- 右菜单 -->
    <div class="notice-btn mutual-opacity" (click)="toggleRightPopup()">
      <img src="assets/svg/trophy.svg" alt="" lazy="loading" />
      <p class="notice-number" *ngIf="carsNumber > 0">
        {{ carsNumber > 99 ? '99+' : carsNumber }}
      </p>
    </div>
  </div>
</div>
